import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React, { useEffect, useState } from 'react';
import KeypadNum from './keypadNum';
import { MESSAGE_TYPE } from '../../constant';

const Keypad = ({ setMobileNumber, showVerifyOTP, setShowNumPad = () => { }, ottSetting }) => {

    const { ref, focusKey, focusSelf, setFocus } = useFocusable({
        focusable: true,
        saveLastFocusedChild: true,
        trackChildren: true,
        autoRestoreFocus: true,
        focusKey: 'KEYPAD',
    });

    const [isQwerty, setIsQwerty] = useState(ottSetting?.authenticationType == MESSAGE_TYPE.EMAIL ? true : false);

    useEffect(() => {
        focusSelf();
    }, [focusSelf, showVerifyOTP]);

    useEffect(() => {
        setFocus('KEYPAD');
    }, [setFocus, showVerifyOTP]);

    const numericButtons = [
        '1', '2', '3',
        '4', '5', '6',
        '7', '8', '9',
        '←', '0', showVerifyOTP ? 'x' : 'ABC'
    ];

    const qwertyButtons = [
        'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p',
        'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '_',
        'z', 'x', 'c', 'v', 'b', 'n', 'm', '.', '@', '-',
        '←', '123'
    ];

    const keypadButtons = isQwerty ? qwertyButtons : numericButtons;

    const handleToggleKeyboard = (val) => {
        if (val === 'ABC') {
            setIsQwerty(true);
        } else if (val === '123') {
            setIsQwerty(false);
        }
    };
    const usedKeys = new Set();

    return (
        <FocusContext.Provider value={focusKey}>
            <div className={`keypadOuterDiv ${isQwerty ? 'qwerty' : 'numeric'}`}>
                <ul
                    id="keypad"
                    ref={ref}
                    className={isQwerty ? 'qwertyLayout' : 'numericLayout'}
                >

                    {keypadButtons.map((button, index) => {
                        if (!usedKeys.has(button)) {
                            usedKeys.add(button);
                            return (
                                <KeypadNum
                                    key={button}
                                    numValue={button}
                                    index={index}
                                    setMobileNumber={setMobileNumber}
                                    showVerifyOTP={showVerifyOTP}
                                    setShowNumPad={setShowNumPad}
                                    isQwerty={isQwerty}
                                    handleToggleKeyboard={handleToggleKeyboard}
                                />
                            );
                        }
                        return null;
                    })}
                </ul>
            </div>
        </FocusContext.Provider>
    );
};

export default Keypad;
